const LocationIcon = ({
  width = '24',
  height = '24',
  color = '#94A3B8',
}: {
  width?: string;
  height?: string;
  color?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 8.67188C4.5 4.67875 7.89479 1.5 12 1.5C16.1052 1.5 19.5 4.67875 19.5 8.67188C19.5 10.923 18.2829 13.7082 16.9495 16.1155C15.5963 18.559 14.0377 20.7603 13.2019 21.8891C13.064 22.0776 12.8837 22.231 12.6755 22.337C12.4663 22.4435 12.2348 22.499 12 22.499C11.7652 22.499 11.5337 22.4435 11.3245 22.337C11.1163 22.231 10.9359 22.0776 10.798 21.889C9.96224 20.7598 8.40373 18.5577 7.05043 16.1139C5.71719 13.7064 4.5 10.9214 4.5 8.67188ZM12 3C8.65209 3 6 5.57656 6 8.67188C6 10.5004 7.03281 12.9859 8.36265 15.3872C9.66887 17.746 11.1818 19.886 12 20.9917C12.8181 19.8865 14.3311 17.7473 15.6374 15.3888C16.9671 12.9878 18 10.5021 18 8.67188C18 5.57656 15.3479 3 12 3Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.5C11.1716 7.5 10.5 8.17157 10.5 9C10.5 9.82843 11.1716 10.5 12 10.5C12.8284 10.5 13.5 9.82843 13.5 9C13.5 8.17157 12.8284 7.5 12 7.5ZM9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9Z"
      fill={color}
    />
  </svg>
);

export default LocationIcon;
